export default __webpack_public_path__ + "static/media/passwordIcon.6857c469.svg";